// extracted by mini-css-extract-plugin
export default {"wrapper":"BackgroundImage_wrapper__4plRm"};